/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./deviceDetails.vue?vue&type=template&id=368936fa&scoped=true"
import script from "./deviceDetails.vue?vue&type=script&lang=js"
export * from "./deviceDetails.vue?vue&type=script&lang=js"
import style0 from "./deviceDetails.vue?vue&type=style&index=0&id=368936fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368936fa",
  null
  
)

export default component.exports